/** Traceability flags for a purchase line or the inventory item linked on a non-stock receipt. */
export type GrnTraceFlags = {
  is_critical?: boolean | null;
  heat_number_mandatory?: boolean | null;
  mtc_required_on_receipt?: boolean | null;
  item_code?: string | null;
};

export function grnLineNeedsHeat(
  poLine: GrnTraceFlags | null | undefined,
  linkedItem: GrnTraceFlags | null | undefined
): boolean {
  const po = Boolean(poLine?.is_critical) && Boolean(poLine?.heat_number_mandatory);
  const linked = Boolean(linkedItem?.is_critical) && Boolean(linkedItem?.heat_number_mandatory);
  return po || linked;
}

export function grnLineNeedsMtc(
  poLine: GrnTraceFlags | null | undefined,
  linkedItem: GrnTraceFlags | null | undefined
): boolean {
  const po = Boolean(poLine?.is_critical) && Boolean(poLine?.mtc_required_on_receipt);
  const linked = Boolean(linkedItem?.is_critical) && Boolean(linkedItem?.mtc_required_on_receipt);
  return po || linked;
}

export function grnTraceItemCode(
  poLine: GrnTraceFlags | null | undefined,
  linkedItem: GrnTraceFlags | null | undefined
): string {
  if (Boolean(linkedItem?.is_critical) && Boolean(linkedItem?.heat_number_mandatory || linkedItem?.mtc_required_on_receipt)) {
    return String(linkedItem?.item_code || poLine?.item_code || '').trim();
  }
  return String(poLine?.item_code || linkedItem?.item_code || '').trim();
}
